<template>

  <b-jumbotron text-variant="white" class="container mt-5 fondo">
    <template slot="header">
      <img class="logo mt-3" src="../assets/logoo-15.png" width="250" style="border-radius:49%">
    </template>
    <p class="bienvenido">
      Bienvenido <br /> 
      {{ getSocio }} ! 
      <br />
      {{ getUltimoAcceso }}
    </p>
    <!-- Ultimo acceso: 25/12/2019 12:33 -->
  </b-jumbotron>

</template>

<script>

import moment from 'moment';

export default {
  name: 'welcome',
  data() {
    return {
      msg: 'Coopexsanjo Ltda.',
    };
  },
   computed: {
    getSocio() {
      return ( window.localStorage.getItem("nombre") || "" ) + ' ' + ( window.localStorage.getItem("apellido") || "" );
    },
    getUltimoAcceso() {
      const ultimo_acceso = window.localStorage.getItem("ultimo_acceso")
      if ( ultimo_acceso ) {
        const fecha = new Date (ultimo_acceso);
        const texto = moment([fecha.getFullYear(), fecha.getMonth(), fecha.getDate(), fecha.getHours(), fecha.getMinutes(), fecha.getMinutes()] ).format('DD/MM/YYYY HH:mm:ss')
        return 'Ultimo acceso: ' + texto;
      } else {
        return '';
      }
    }

  }
};
</script>

<style scoped>

.fondo {
  background-color: #2153A0;
  height: 360px;
  opacity: .9;
  width: 720px;
  padding: 0px;
}

.bienvenido {
  color: white;
  font-family: Montserrat;
  font-weight: bold;
  font-size: 18px;
}

</style>